import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'

Vue.use(VueRouter)

import User from '../components/pages/User'
import Login from '../components/pages/Login'
import WIP from '../components/pages/WIP'
import Home from '../components/pages/Dashboard'
import Clients from '../components/pages/Clients'
import Client from '../components/pages/Client'
import Projects from '../components/pages/Projects'
import Project from '../components/pages/Project'
import AppBuilds from '../components/pages/AppBuilds'
import Task from '../components/pages/Task'
import Users from '../components/pages/Users'
import Reports from '../components/pages/Reports'

import store from '../vuex/store'

import {COOKIE_DOMAIN, COOKIE_SECURE} from '../config'

/**
 * VueRouter Config - Defines our paths and the Custom components for each path
 * Note: The router mounts into the App component (see components/App.vue)
 */
const router = new VueRouter({
  routes: [
    // Login Route - The Login Form
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Login
    },

    // Home Route - The App Dashboard
    {
      path: '/home',
      name: 'home',
      component: Home
    },

    // WIP - Work In Progress
    {
      path: '/wip',
      name: 'wip',
      component: WIP
    },

    // Clients Route - List of all Clients
    {
      path: '/clients',
      name: 'clients',
      component: Clients
    },
    {
      path: '/clients/:client_id',
      name: 'client',
      component: Client
    },

    // Projects Route - List of all Projects
    {
      path: '/projects',
      name: 'projects',
      component: Projects
    },
    {
      path: '/projects/:project_id',
      component: Project,
      name: 'project'
    },

    // Tasks Route - List of all Tasks
    {
      path: '/tasks/:task_id',
      name: 'task',
      component: Task
    },

    // MLaunch Route - List of all App Builds
    {
      path: '/app-builds',
      name: 'app-builds',
      component: AppBuilds
    },
    {
      path: '/users/:user_id',
      name: 'user',
      component: User
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },

    {
      path: '/reports',
      name: 'reports',
      component: Reports
    },

    // My Account - View and Edit your own account
    {
      path: '/account',
      name: 'account',
      component: User
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})

// Guard the routes by checking for an existing access token
router.beforeEach((to, from, next) => {
  // If the access token exists, let the user access anywhere but the login route
  if (store.state.accessToken !== false) {
    // Make sure the Access Token Cookie is up-to-date. This will also refresh the expires of the cookie on each page load :)
    setAccessTokenCookie(store.state.accessToken)
    if (to.name === 'logout') {
      store.dispatch('logout')
      next('/login')
    }

    if (to.name === 'clear-cache') {
      store.dispatch('clearCache')
      next('/login')
    }

    if (to.name === 'login') {
      next('/home')
    } else {
      next()
    }
    if (to.name === 'reports' && store.state.users.currentUser && !store.state.users.currentUser.access_reports) {
      next('/home')
    } else {
      next()
    }
  } else {
    removeAccessTokenCookie()
    store.dispatch('logout')
    // If the access token does not exist, force the user to the login route
    if (to.name !== 'login') {
      next('/login')
    } else {
      next()
    }
  }
})

// Update the current route name in vuex state each time the route changes
// This is used for navbar active states
router.afterEach((to) => {
  store.dispatch('setCurrentRouteName', to.name)
})

export default router


function setAccessTokenCookie(accessToken) {
  Cookies.set(
      'access_token',
      accessToken,
      {
        expires: 365,
        domain: COOKIE_DOMAIN,
        secure: COOKIE_SECURE
      }
  );
}

function removeAccessTokenCookie() {
  Cookies.remove('access_token', { domain: COOKIE_DOMAIN });
}

